import { type ProfileFlags, useMyProfile } from '@shared/profile';
import type { UserType } from '@api-client/temporary-messages';
import { isJuniorAccount } from '@shared/junior-utils';

export const useUserTypeQueryParam = (): UserType => {
    const { data: profile } = useMyProfile();

    if (!profile || !profile.flags) {
        return 'REGULAR';
    }

    const isJunior = isJuniorAccount<ProfileFlags[]>(profile.flags);

    return isJunior ? 'JUNIOR' : 'REGULAR';
};
